import { module } from 'stereomodularjs';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.splitWords = new SplitText(this.el, { type: 'words', wordsClass: 'u-anim-word' });
        this.words = this.splitWords.words;
        this.words.forEach((line, i) => {
            line.style.transitionDelay = `${i * 0.05}s`;
        });
    }

    destroy() {
        
    }
}
